import { PATH } from '@/utils/routes';
import AllModalContainer from '../AllModalContainer';
import { DeleteIcon, ExitIcon, OrderIcon } from '../../svgExports';
import { handleRouteChangesOnClick } from '@/utils/handleRouteChangesOnClick';
import { useState } from 'react';
import { toastNotifySuccess } from '@/components/Common/Toast';
import { useDispatch, useSelector } from 'react-redux';
import { ActionTab } from '../Common';
import { deleteUserAccount } from '@/redux/actions';
import { executeLogout } from '@/utils/excuteLogout';

const UserOptions = () => {
  const { storeId, userId } = useSelector((state) => ({
    storeId: state.storeReducer.store?.store_id,
    userId: state.userReducer?.data?.user_id || '',
  }));
  const dispatch = useDispatch();

  const [modalState, setModalState] = useState({
    showLogoutConfirmationModal: false,
    showConfirmationModal: false,
    showFeedbackModal: false,
    showVerifyOtpModal: false,
  });
  const [feedback, setFeedback] = useState('');

  const OPTIONS = [
    {
      Icon: OrderIcon,
      text: 'Orders',
      handler: onOrdersClick,
    },
    {
      Icon: DeleteIcon,
      text: 'Delete account',
      handler: onDeleteAccountClick,
    },
    {
      Icon: ExitIcon,
      text: 'Log out',
      handler: toggleLogoutModal,
    },
  ];

  /* --- page cta actions --- */
  function onOrdersClick() {
    handleRouteChangesOnClick(PATH.ORDERS);
  }

  function onDeleteAccountClick() {
    setModalState({
      ...modalState,
      showConfirmationModal: true,
    });
  }

  function toggleLogoutModal() {
    setModalState({
      ...modalState,
      showLogoutConfirmationModal: !modalState.showLogoutConfirmationModal,
    });
  }

  /* --- modal cta actions --- */
  function onConfirmAccountDelete() {
    setModalState({
      ...modalState,
      showConfirmationModal: false,
      showFeedbackModal: true,
    });
  }

  function onSubmitFeedback(text) {
    setFeedback(text);
    setModalState({
      ...modalState,
      showFeedbackModal: false,
      showVerifyOtpModal: true,
    });
  }

  function onDeletetionSuccess() {
    toastNotifySuccess('Account deleted successfully!');
    executeLogout();
  }

  function onOtpVerificationSuccess() {
    const payload = {
      store_id: storeId,
      user_id: userId,
      feedback: feedback,
    };
    dispatch(deleteUserAccount(payload, onDeletetionSuccess));
  }

  return (
    <main>
      <div className="tw-flex tw-flex-col">
        {OPTIONS.map((option, index) => (
          <ActionTab {...option} key={index} />
        ))}
      </div>
      <AllModalContainer
        modalState={modalState}
        setModalState={setModalState}
        onConfirmAccountDelete={onConfirmAccountDelete}
        onSubmitFeedback={onSubmitFeedback}
        onOtpVerificationSuccess={onOtpVerificationSuccess}
      />
    </main>
  );
};

export default UserOptions;
